const es = {
  months: {
    short: {
      0: 'Ene',
      1: 'Feb',
      2: 'Mar',
      3: 'Abr',
      4: 'May',
      5: 'Jun',
      6: 'Jul',
      7: 'Ago',
      8: 'Sep',
      9: 'Oct',
      10: 'Nov',
      11: 'Dic'
    }
  },
  errorBoundary: {
    title: 'Algo salió mal',
    message: 'Esta pantalla tuvo un problema. Recarga para continuar.',
    reload: 'Recargar'
  },
  session: {
    to_many_user_login:
      'Hay demasiadas conexiones. Cierra otras sesiones para continuar',
    connectionCheck: 'No se puede contactar con el servidor - ',
    connectionRestore:
      'Restaura la conexión a internet para sincronizar los cambios.',
    checkConnection: 'verifique su conexión',
    tryAgain: ' e inténtelo de nuevo.'
  },
  signIn: {
    enter_name: 'Ingrese el nombre en el campo',
    saved_msg: 'Guardado Exitosamente'
  },
  clickScanConfirmation: {
    scan_confirmation_pop_msg:
      'Esta es una nota para el empacador. Se requiere confirmación para esta nota.',
    scan_confirmation_pop_errormsg:
      'Ingrese o escanee su código de confirmación para continuar'
  },
  AddNextBarcode: {
    search_item_msg:
      'Escanee el artículo que desea agregar a este pedido para continuar.',
    confirmation_code_msg:
      'Por favor, escanee o ingrese el código de confirmación de un usuario con permisos para editar pedidos.'
  },
  scanpackItem: {
    shippingEsaySameOrderTextAlert:
      'Los siguientes pedidos comparten un número de orden similar. Toca aquí para cambiar.',
    shipStationSameOrderText:
      'Los siguientes pedidos comparten el mismo número de orden. Toca aquí para cambiar.',
    Scanpack_Item_tracking_msg:
      '¡Vaya! El número de seguimiento que ha escaneado no parece ser válido. Si está seguro de que es correcto, pida a un administrador que verifique la configuración de validación del número de seguimiento en Configuración > Sistema > Escanear y Empacar > Funciones posteriores al escaneo.',
    Scanpack_Item_shipping_msg_two:
      'Para omitir esta verificación, ingrese un código de confirmación con permisos para editar pedidos.',
    Scanpack_type_count_msg:
      'Por favor, escanee el artículo una vez antes de activar el conteo manual.',
    Disable_type_count_msg: 'La función de conteo manual está deshabilitada.',
    Disable_skip_msg:
      'La función de omisión está deshabilitada o el código de barras es incorrecto.',
    Scanpack_multipack_msg:
      'El código de barras multipack escaneado excede la cantidad restante.',
    Scan_correct_barocde:
      'Por favor, escanee los artículos en el orden sugerido.',
    not_fulfilled_failed:
      'No se pudo marcar el artículo como no cumplido. Revise la conexión e inténtelo de nuevo.',
    add_barcode_failed:
      'No se pudo guardar el código de barras. Revise la conexión e inténtelo de nuevo.',
    Scanpack_pass_fun_msg: 'La función de pase está deshabilitada.',
    Scanpack_required_serial_msg:
      "El valor escaneado no parece ser un número de serie o lote válido. Verifique la configuración 'Requerir prefijo de serie/lote' en las opciones de escaneo y empaquetado.",
    Scanpack_barcode_found_or_special_code_msg:
      'El valor ingresado coincide con un código de confirmación de usuario, uno de los códigos de acción o un código de barras de producto. Comuníquese con el soporte si necesita este valor.',
    Scanpack_Item_Shipment: '¡Envío no encontrado!',
    Scanpack_Item_Typecount_exceed_error:
      'La cantidad ingresada excede el número restante de piezas en el pedido. Por favor, inténtelo de nuevo.',
    addBar_text: 'Revise cuidadosamente el artículo antes de escanear.',
    restartAlert:
      '¿Está seguro de que desea restablecer todo el progreso de escaneo para este pedido?',
    service_Issue_msg: 'Pedido con problema de servicio.',
    service_Issue_msg_one:
      'El estado de este pedido es “Problema de servicio”. Para cambiar el estado a “En espera” y poder escanearlo, escanee o ingrese su código de confirmación. Si desea escanear un pedido diferente, puede escanear otro número de pedido para continuar.',
    service_Issue_msg_two:
      'El estado de este pedido es “Problema de servicio”. Para cambiar el estado a “En espera”, pida a un miembro del equipo con permisos para editar pedidos que escanee o ingrese su código de confirmación. Si desea escanear un pedido diferente, puede escanear otro número de pedido para continuar.',
    service_Issue_notification:
      'El código de confirmación ingresado no es válido.',
    service_Issue_notification_one:
      'El código de confirmación ingresado no está asociado a un usuario con permisos para editar pedidos.',
    refreshTooltip:
      'El botón de importación iniciará una importación de pedidos desde todas las fuentes activas de la cuenta. Puede verificar el estado de una importación en progreso usando el botón de actualizar.',
    addBarText: 'Se guardará y se marcará como escaneado.',
    trackingSubmit: `El número de seguimiento en la etiqueta de envío que acaba de escanear no coincide con el número de seguimiento importado con ese pedido. Verifique que tiene la etiqueta de envío correcta y vuelva a escanear. Si está al tanto del problema y desea continuar con el siguiente pedido, escanee su código de confirmación para proceder.`,
    moreToScanLabel: 'más por escanear',
    outOfStockLabel: 'Reportar fuera de stock',
    scannedLabel: 'Escaneado',
    uploadSyncLabel:
      'Por favor, conéctate a Internet para subir tus datos de escaneo.',
    typeInCountLabel: 'Conteo manual'
  },
  nextItems: {
    passButtonLabel: 'Aprobar',
    scanAllLabel: 'ESCANEAR\nTODO',
    clickScanLabel: 'Haga clic aquí antes de escanear',
    tabHereLabel: 'Toque aquí antes de escanear',
    readyForScanLabel: 'Listo para escanear el producto',
    scanToteToContinue: '¡Escanea una bandeja para continuar!',
    gotItLabel: 'Entendido.',
    noOrderToScan: 'No hay pedidos para escanear.',
    noItemsToScan: 'No quedan artículos por escanear.',
    serialRecordingNote:
      'El siguiente artículo requiere registrar un número de serie.',
    serialRecordingNoteTwo:
      'El siguiente artículo requiere registrar dos números de serie.',
    restartButton: {
      firstLabel: 'Reiniciar',
      secondLabel: 'Pedido'
    },
    reloadButton: 'Recargar',
    addNoteButton: {
      firstLabel: 'Agregar',
      secondLabel: 'Nota'
    },
    activityLogLabel: 'Registro de actividades',
    tryAgainLabel: 'Por favor, inténtelo de nuevo.',
    barcodeScanned: 'El código de barras que ha escaneado',
    doesNotMatch:
      'no coincide con el número de seguimiento importado con este pedido.',
    addBarCodeLabel: 'AGREGAR UN CÓDIGO DE BARRAS',
    changesSaveLabel: 'Cambios guardados exitosamente',
    youLabel: 'Tú',
    leaderLabel: 'Líder',
    youAreInLead: 'Estás en la delantera ',
    unScannedLabel: 'Artículos no escaneados',
    scannedLabel: 'Artículos escaneados',
    unScannedLabelMobile: 'No escaneados',
    scannedLabelMobile: 'Escaneados',
    not_fulfilled: 'No Cumplido',
    not_fulfilled_items: 'Artículos No Cumplidos'
  },
  popupTracking: {
    noTracingFound: 'No se puede verificar la etiqueta de envío',
    noUser_permission_text_one:
      'Para continuar, puede escanear una etiqueta de envío con un código de seguimiento que coincida con el número de seguimiento asociado con el pedido actual, o puede omitir esta verificación ingresando un código de confirmación con permisos para editar pedidos.',
    noUser_permission_text_two:
      'Si ninguna de estas opciones está disponible, puede cerrar esta notificación y regresar a este pedido más tarde para verificar la etiqueta de envío. El pedido aparecerá en la lista de pendientes hasta que la etiqueta de envío sea verificada.',
    header: 'Por favor, inténtelo de nuevo'
  },
  adminTools: {
    searchScopeSomeCustomer:
      'Se buscó en la sección del equipo de GroovePacker y en la del cliente. Algunas coincidencias están en la sección del cliente, así que {{tenant}} puede verlas.',
    searchScopeAllCustomer:
      'Se buscó en la sección del equipo de GroovePacker y en la del cliente. Todas las coincidencias están en la sección del cliente, así que {{tenant}} puede verlas.',
    searchNoMatchesTitle: 'Ninguna configuración coincide con "{{query}}"',
    searchNoMatchesBody:
      'Se buscó en nombres, textos de ayuda y grupos de ambas secciones.',
    searchClear: 'Borrar búsqueda',
    adminToolsTitle: 'Admin Tools',
    teamBandTitle: 'Solo para el equipo de GroovePacker',
    teamBandDescription:
      'El cliente nunca ve esta sección. Estos interruptores controlan planes, funciones y herramientas internas.',
    teamOnly: 'Solo equipo',
    teamMenuTenants: 'Cuentas',
    teamMenuUtilities: 'Utilidades',
    teamMenuReportBug: 'Reportar un error',
    teamMenuLogOut: 'Cerrar sesión',
    customerBandTitle: 'Configuración del cliente',
    customerBandDescription:
      'La misma configuración que {{tenant}} tiene en su propia página de configuración. Los cambios aquí se aplican de inmediato.',
    customerAlsoSees: 'El cliente también ve esto',
    customerSeesThese: 'El cliente ve esto',
    bridgeLine: 'Todo lo que sigue también lo ve {{tenant}}',
    searchPlaceholder:
      'Buscar cualquier configuración por nombre, descripción o grupo',
    searchPlaceholderShort: 'Buscar en toda la configuración',
    searchMatchCount: {
      one: '{{count}} coincidencia en {{groups}} {{groupsWord}}',
      other: '{{count}} coincidencias en {{groups}} {{groupsWord}}'
    },
    searchGroupsWord: {
      one: 'grupo',
      other: 'grupos'
    },
    groupMatchCount: {
      one: '1 coincidencia',
      other: '{{count}} coincidencias'
    },
    searchScopeAllTeam:
      'Se buscó en la sección del equipo de GroovePacker y en la del cliente. Todas las coincidencias están en la sección del equipo, así que {{tenant}} no puede verlas.',
    groupOnCount: '{{on}} de {{total}} activados',
    movedFromCustomer: 'Movido desde el cliente',
    movedFromCustomerLine:
      'Movido desde la página de configuración del cliente',
    saveFailed: 'No se pudo guardar: {{error}}',
    unknownError: 'Error desconocido',
    invalidNumber: 'Ingrese un número válido',
    minValue: 'Debe ser al menos {{min}}',
    maxValue: 'Debe ser como máximo {{max}}',
    aboutSetting: 'Información sobre {{label}}',
    groupErrors: {
      one: '1 error',
      other: '{{count}} errores'
    },
    unknownSettingType:
      'Tipo de configuración desconocido "{{type}}" para "{{key}}"'
  },
  customerSettings: {
    maxTotesForSet: 'Máximo de totes: {{name}}',
    userRoleLabel: '{{name}} · {{role}}',
    noStores: 'No hay tiendas conectadas',
    noUsers: 'Sin usuarios',
    groupGeneral: 'General',
    groupGeneralDescription: 'Zona horaria, correos y alertas',
    timeZone: 'Zona horaria',
    timeZoneTooltip:
      'Se usa para la hora de los reportes y de las importaciones programadas.',
    billingNotificationEmail: 'Correo para avisos de facturación',
    billingNotificationEmailTooltip:
      'Los avisos de facturación se envían aquí. Al cambiarlo también se actualiza el correo de la cuenta de Stripe.',
    outOfStockReportEmail: 'Correo para el reporte de productos agotados',
    outOfStockReportEmailTooltip: 'Recibe el reporte de productos agotados.',
    lowInventoryAlertLimit: 'Límite de alerta de inventario bajo',
    lowInventoryAlertLimitTooltip:
      'Nivel de alerta predeterminado para los productos que no tienen uno propio. Se envía una alerta cuando el inventario llega a esta cantidad o menos.',
    groupScanPack: 'Escanear y empacar',
    groupScanPackDescription: 'Comportamiento de la pantalla de empaque',
    includeActionRequiredOrders: 'Incluir pedidos que requieren acción',
    includeActionRequiredOrdersTooltip:
      'Muestra en la fila de escaneo y empaque los pedidos que requieren acción.',
    suppressSoftwareKeyboard: 'Ocultar el teclado en pantalla',
    suppressSoftwareKeyboardTooltip:
      'Oculta el teclado en pantalla en los dispositivos con escáner.',
    boxScanVerification: 'Verificación de escaneo de caja',
    boxScanVerificationTooltip:
      'Pide al empacador escanear la caja antes de cerrar un pedido.',
    orderNumberFallbackPrefixes: 'Prefijos de número de pedido a probar',
    orderNumberFallbackPrefixesTooltip:
      'Prefijos que se prueban cuando no se encuentra un número de pedido. Hasta 10.',
    toteIdentifier: 'Identificador de tote',
    toteIdentifierTooltip:
      'Palabra que se muestra para los totes en la pantalla de empaque.',
    maxTotes: 'Máximo de totes',
    maxTotesTooltip:
      'Cantidad de totes que se crean para el flujo Scan to Cart.',
    groupPrinting: 'Impresión',
    groupPrintingDescription: 'Etiquetas y comprobantes de empaque',
    productBarcodeLabelSize:
      'Tamaño de la etiqueta de código de barras del producto',
    productBarcodeLabelSizeTooltip:
      'Tamaño que se usa al imprimir etiquetas de código de barras de productos.',
    packingSlipSize: 'Tamaño del comprobante de empaque',
    packingSlipSizeTooltip:
      'Tamaño de papel que se usa para los comprobantes de empaque.',
    groupStores: 'Tiendas',
    groupStoresDescription: {
      one: '1 tienda conectada',
      other: '{{count}} tiendas conectadas'
    },
    storeImportingHourly: 'Importa cada hora',
    storeImportingEvery: 'Importa cada {{minutes}} min',
    storeManual: 'Manual',
    listUnavailable: 'No se pudo leer esta lista desde el servidor',
    storeInactive: 'Inactiva',
    edit: 'Editar',
    groupUsers: 'Usuarios',
    groupUsersDescription:
      '{{regular}} de {{regularLimit}} regulares, {{admin}} de {{adminLimit}} solo administrativos',
    usersPillRegular: '{{count}}/{{limit}} regulares',
    usersPillAdminOnly: '{{count}}/{{limit}} solo administrativos',
    userTagRegular: 'Regular',
    userTagAdminOnly: 'Solo administrativo',
    usersShowAll: 'Ver todos los usuarios'
  },
  adminTenantPage: {
    loading: 'Cargando {{tenant}}...',
    loadFailedTitle: 'No se pudo cargar {{tenant}}',
    loadFailedBody:
      'El servidor no respondió ({{status}}). No se muestra ninguna configuración porque no se pudo leer, y no se cambió nada.',
    loadFailedBanner:
      'No se pudo actualizar esta página. La configuración mostrada puede estar desactualizada.',
    backToTenants: 'Volver a las cuentas',
    dismiss: 'Descartar',
    saveRejected: 'El servidor rechazó la solicitud',
    noSaveRoute:
      'Esta configuración aún no se puede guardar desde esta página.',
    actionDone: 'Listo',
    unknownValue: 'Desconocido',
    noNote: 'Sin nota',
    didNotSave: 'El servidor no guardó este cambio.',
    noShopifyStore: 'Esta cuenta no tiene una tienda de Shopify conectada.',
    notFoundTitle: '{{tenant}} ya no existe',
    forbidden:
      'Tu cuenta ya no tiene acceso de equipo. Inicia sesión de nuevo.',
    statusDeleted: 'Eliminada',
    deletedBanner:
      'Esta cuenta está eliminada. Sus usuarios no pueden iniciar sesión, y su configuración no se puede editar aquí hasta que se restaure.',
    saved: 'Guardado',
    savedFor: 'Guardado para {{tenant}}',
    billingConfirm: 'Confirmar cambio de facturación',
    billingPerMonth: ' al mes',
    billingPerYear: ' al año',
    billingAddonOn:
      '¿Activar {{addon}} para {{tenant}} por {{amount}}{{per}}?',
    billingAddonOff:
      '¿Desactivar {{addon}} para {{tenant}}? Ahora cuesta {{amount}}{{per}}.',
    billingAddonAmount:
      '¿Cambiar {{addon}} para {{tenant}} de {{from}} a {{to}}?',
    billingChargeAdded:
      'Esto agrega {{amount}}{{per}} a la suscripción de Stripe de {{tenant}}. No se cobra nada ahora. Stripe agrega a la próxima factura cualquier cargo prorrateado por el resto de este período; durante una prueba, la facturación empieza cuando termina la prueba.',
    billingChargeRemoved:
      'Esto quita el complemento de la suscripción de Stripe de {{tenant}}. No se cobra nada ahora. Stripe acredita en la próxima factura el tiempo no usado, si lo hay.',
    billingNoCharge:
      'El complemento está desactivado, así que no se le cobra a {{tenant}}. El nuevo importe se usará cuando se active.',
    billingDoubleCharge:
      'Atención: {{tenant}} ya paga {{from}}{{per}} por este complemento. Al guardar se agrega un segundo cargo de {{to}}{{per}} y no se quita el cargo de {{from}}. Quita el cargo anterior en Stripe a mano.',
    billingReprice:
      'Guardar {{setting}} cambia la suscripción de {{tenant}} de {{from}} a {{to}}{{per}} (usuarios normales × $50 + usuarios solo administradores × $10). No se cobra nada ahora. Stripe agrega a la próxima factura cualquier diferencia prorrateada; durante una prueba, el nuevo precio empieza cuando termina la prueba.',
    billingShopifyEmail:
      '{{tenant}} paga a través de Shopify. Guardar {{setting}} le envía un correo para aprobar el cargo de su plan.',
    billingAddonNoStripe:
      '{{tenant}} no tiene una suscripción de Stripe (paga a través de Shopify o no tiene ninguna), así que esto no se factura en Stripe. Al guardar, el complemento se guarda en GroovePacker.',
    billingNotApplied:
      'Stripe no aplicó el cambio de facturación de {{tenant}}. La configuración quedó guardada en GroovePacker, pero la suscripción en Stripe no cambió. Revísala en Stripe.',
    billingChargeChanged:
      'Stripe cambia el cargo existente de {{tenant}} de {{from}} a {{to}}{{per}}. No se cobra nada ahora. Stripe agrega a la próxima factura cualquier diferencia prorrateada; durante una prueba, el nuevo precio empieza cuando termina la prueba.',
    billingErrorDetail: 'Detalle: {{error}}',
    billingRepriceNotApplied:
      'No se registró el nuevo precio de {{tenant}}. La configuración quedó guardada en GroovePacker, pero es posible que Stripe haya cambiado en parte. Revisa la suscripción en Stripe.',
    billingRepriceRecorded:
      'GroovePacker registró el nuevo precio de {{tenant}}: {{amount}}{{per}}. Desde aquí no se puede confirmar que Stripe lo aplicó; revisa la suscripción en Stripe si el guardado te pareció raro.',
    billingNotConfirmed:
      'Facturación sin confirmar para {{tenant}}. La configuración quedó guardada en GroovePacker, pero desde aquí no se puede saber si Stripe aplicó el cambio. Revisa la suscripción en Stripe.',
    sideEffectsTitle: 'También se hizo automáticamente',
    duplicate: 'Duplicar',
    statusActive: 'Activa',
    testTenantOn: 'Cuenta de prueba: sí',
    testTenantOff: 'Cuenta de prueba: no',
    statPlan: 'Plan',
    statShipmentsThisMonth: 'Envíos este mes',
    statStores: 'Tiendas',
    countOfLimit: '{{count}} de {{limit}}',
    note: 'Nota',
    deleteTenant: 'Eliminar cuenta',
    restoreDeletedTenant: 'Restaurar cuenta eliminada',
    sideEffect: {
      inventory_process:
        'El inventario se está procesando para todos los pedidos sin escanear.',
      users_packing_slip_size_reset:
        'Se cambió el tamaño del albarán de cada usuario para que coincida.',
      inventory_unprocess:
        'El inventario se está revirtiendo para todos los pedidos sin escanear.',
      stripe_billing_email_synced:
        'El correo de la cuenta de Stripe se actualizó para que coincida.',
      import_job_scheduled: 'Se programó la siguiente importación.',
      tote_sets_rebuilt: 'Los totes se reconstruyeron con el nuevo máximo.',
      se_import_log_cleared:
        'Se eliminó el registro guardado de importaciones de pedidos de la tienda.',
      schedule_import_mode_reset:
        'La programación de importación volvió a Diaria.',
      dashboards_reset: 'Se restableció a ninguno el panel de cada usuario.',
      shopify_limits_not_applied:
        'Cuenta facturada por Shopify: los nuevos límites se guardaron aquí pero la facturación de Shopify no cambió.',
      subscription_not_repriced_blank_id:
        'El ID de suscripción de Stripe está vacío, así que no se actualizó el precio de la suscripción.',
      unknown:
        'El servidor informó un efecto adicional sin descripción: {{effect}}'
    },
    groupPlanBilling: 'Plan y facturación',
    groupPlanBillingDescription:
      'Plan, límites y complementos solo de facturación',
    billingOnlyNote:
      'Solo facturación. Estos cuatro interruptores cambian la factura, no lo que la cuenta puede hacer.',
    addonPerUser: 'por usuario / mes',
    addonMonthlyAmount: '= ${{amount}} / mes',
    addonPerUserBreakdown: '{{count}} usuarios regulares × ${{price}}',
    addonFlat: 'Tarifa fija, una vez al mes',
    addonNotBilled: 'No se factura',
    addonOff: 'El complemento está desactivado',
    stripeSubLabel: 'Stripe',
    groupInventoryImport: 'Controles de inventario e importación',
    groupFeatures: 'Funciones',
    groupFeaturesDescription:
      'Interruptores que activan funciones del producto para esta cuenta',
    groupWorkflow: 'Flujo de trabajo e integraciones',
    groupWorkflowDescription:
      'Flujo de escaneo, acciones posteriores al escaneo y opciones de la API de Shopify',
    groupImportUtilities: 'Utilidades de importación',
    groupImportUtilitiesDescription:
      'Comportamiento de importación y herramientas de soporte',
    groupLogging: 'Registros',
    groupLoggingDescription: 'Enviar eventos a Loggly para depuración',
    groupInventoryPush: 'Envío de inventario',
    groupInventoryPushDescription:
      'Enviar los niveles de inventario de vuelta a la tienda'
  },
  tenantSettings: {
    importTime: 'Hora de importación',
    scheduleOnOff: 'Ejecutar esta programación',
    invalidTime: 'Ingresa una hora como 06:30',
    rangeOrder: 'La hora de inicio debe ser anterior a la hora de fin',
    addonPrice: 'Precio',
    plan: 'Plan',
    planTooltip:
      'Plan de suscripción. Al cambiarlo se actualiza la suscripción de Stripe de esta cuenta.',
    highSku: 'High SKU',
    highSkuTooltip:
      'Complemento de facturación para inventario con muchos SKU. No activa ninguna función.',
    doubleHighSku: 'Double High SKU',
    doubleHighSkuTooltip:
      'Complemento de facturación para estanterías de SKU de doble altura. No activa ninguna función.',
    custMaintenance1: 'Mantenimiento personalizado 1',
    custMaintenance1Tooltip:
      'Complemento de facturación para servicios de mantenimiento personalizado. No activa ninguna función.',
    custMaintenance2: 'Mantenimiento personalizado 2',
    custMaintenance2Tooltip:
      'Complemento de facturación para servicios adicionales de mantenimiento personalizado. No activa ninguna función.',
    stripeCustomerId: 'ID de cliente de Stripe',
    stripeCustomerIdTooltip:
      'Solo la cuenta gpadmin puede ver y editar este dato.',
    stripeSubscriptionId: 'ID de suscripción de Stripe',
    stripeSubscriptionIdTooltip:
      'Solo la cuenta gpadmin puede ver y editar este dato.',
    inventoryTracking: 'Seguimiento de inventario',
    inventoryTrackingTooltip:
      'Al activarlo o desactivarlo se reprocesa el inventario de todos los pedidos sin escanear. Puede tardar en cuentas grandes.',
    generateNumericBarcodes: 'Generar códigos de barras numéricos',
    generateNumericBarcodesTooltip:
      'Longitud y valor inicial de los códigos de barras que genera GroovePacker. El primer dígito no puede ser 0.',
    numericBarcodeLength: 'Longitud',
    numericBarcodeStartValue: 'Valor inicial',
    removeZeroQuantityItems: 'Eliminar artículos del pedido con cantidad cero',
    removeZeroQuantityItemsTooltip:
      'Descarta las líneas de pedido con cantidad 0 al importar pedidos.',
    preDayImportSchedule: 'Horario de importación de pedidos del día anterior',
    preDayImportScheduleTooltip:
      'Importa pedidos una vez al día a la hora elegida, o cada hora cuando Importación de pedidos cada hora está activada.',
    importModeDaily: 'Diario',
    importModeHourly: 'Cada hora',
    recurringFtpImportRange:
      'Rango de importación recurrente de pedidos por FTP',
    recurringFtpImportRangeTooltip:
      'Horas del día en las que pueden ejecutarse las importaciones de pedidos por FTP.',
    rangeFrom: 'Desde',
    rangeTo: 'a',
    hourAm: 'a. m.',
    hourPm: 'p. m.',
    hourEndOfDay: '11:59 p. m.',
    multiBox: 'Varias cajas',
    multiBoxTooltip:
      'Permite empacar un pedido en varias cajas en lugar de un solo envío.',
    boxChamp: 'BoxChamp',
    boxChampTooltip:
      'Permite que BoxChamp elija la mejor caja para cada pedido y así reducir el peso dimensional y el costo de envío.',
    amazonFba: 'Amazon FBA',
    amazonFbaTooltip:
      'Activa el cumplimiento con Amazon FBA para que los pedidos se envíen a los centros de Amazon.',
    realTimePackerStats: 'Estadísticas de empacadores en tiempo real',
    realTimePackerStatsTooltip:
      'Muestra en el tablero estadísticas de empaque en vivo de cada empacador.',
    hourlyOrderImport: 'Importación de pedidos cada hora',
    hourlyOrderImportTooltip:
      'Importa pedidos de las tiendas conectadas cada hora.',
    productFtpImport: 'Importación de productos por FTP',
    productFtpImportTooltip:
      'Importa información de productos al catálogo desde un servidor FTP.',
    inventoryReportOption: 'Opción de reporte de inventario',
    inventoryReportOptionTooltip:
      'Da acceso a reportes del estado del inventario y su historial.',
    postScanningApiCall: 'Llamada a API después del escaneo',
    postScanningApiCallTooltip:
      'Llama a un webhook externo cada vez que se escanea un artículo durante el empaque.',
    groovelyticsStats: 'Estadísticas de Groovelytics',
    groovelyticsStatsTooltip:
      'Registra y muestra métricas de precisión y rendimiento del escaneo.',
    enableDeveloperTools: 'Activar herramientas para desarrolladores',
    enableDeveloperToolsTooltip:
      'Da acceso a la API externa para desarrolladores, para integraciones personalizadas.',
    dailyPackedPercent: '% empacado diario',
    dailyPackedPercentTooltip:
      'Activa el reporte diario del porcentaje de pedidos empacados y enviados.',
    postImportRulesEngine: 'Motor de reglas posteriores a la importación',
    postImportRulesEngineTooltip:
      'Aplica reglas personalizadas a los pedidos justo después de importarlos.',
    packingCam: 'Packing Cam',
    packingCamTooltip:
      'Toma fotos durante el empaque para registros de calidad y servicio al cliente.',
    voicePacking: 'Empaque por voz',
    voicePackingTooltip:
      'Permite que los empacadores escuchen instrucciones de empaque habladas en GPX.',
    newScanPackInterface: 'Nueva interfaz de Escanear y empacar',
    newScanPackInterfaceTooltip:
      'Cambia la cuenta a la pantalla nueva de escaneo y empaque.',
    scanToScore: 'Scan to score',
    scanToScoreTooltip:
      'Muestra a los empacadores un puntaje en la pantalla de escaneo y empaque mientras escanean.',
    scanWorkflow: 'Flujo de escaneo',
    scanWorkflowTooltip:
      'Define cómo trabajan los empacadores: Predeterminado, Product First, Multi Put Wall, Pick Tote o Scan to Cart.',
    scanWorkflowDefault: 'Predeterminado',
    scanWorkflowProductFirst: 'Product First',
    scanWorkflowMultiPutWall: 'Multi Put Wall',
    scanWorkflowPickTote: 'Pick Tote',
    scanWorkflowScanToCart: 'Scan to Cart',
    postScanningOptionsV2: 'Opciones posteriores al escaneo V2',
    postScanningOptionsV2Tooltip:
      'Ejecuta acciones después del escaneo en GPX, como imprimir etiquetas o actualizar el seguimiento.',
    shopifyGraphqlOrderImport: 'Importación de pedidos de Shopify con GraphQL',
    shopifyGraphqlOrderImportTooltip:
      'Usa la API GraphQL de Shopify, más rápida, para importar pedidos en lugar de REST.',
    shopifyGraphqlProductImport:
      'Importación de productos de Shopify con GraphQL',
    shopifyGraphqlProductImportTooltip:
      'Usa la API GraphQL de Shopify para importar productos.',
    shopifyGraphqlWrites:
      'Escrituras en Shopify con GraphQL (etiquetas y cumplimiento)',
    shopifyGraphqlWritesTooltip:
      'Envía a Shopify las actualizaciones de cumplimiento y las etiquetas mediante GraphQL.',
    shopifyTrackingLookup: 'Búsqueda por número de seguimiento de Shopify',
    shopifyTrackingLookupTooltip:
      'Cuando un número de seguimiento escaneado no coincide con ningún pedido, busca el pedido de Shopify que lo tiene y lo importa a pedido. Requiere activar la importación de pedidos de Shopify con GraphQL.',
    shipworksImportWithDelay: 'Importación de ShipWorks con demora',
    shipworksImportWithDelayTooltip:
      'Importa los pedidos de ShipWorks en lotes con demora en lugar de uno por uno.',
    inventoryUpdateWithDelay: 'Actualización de inventario con demora',
    inventoryUpdateWithDelayTooltip:
      'Agrupa las actualizaciones de inventario en segundo plano en lugar de hacerlas pedido por pedido.',
    showExternalLogsButton: 'Mostrar botón de registros externos',
    showExternalLogsButtonTooltip:
      'Muestra un botón para ver los registros de sistemas externos.',
    orderCupDirectShipping: 'Envío directo de OrderCup',
    orderCupDirectShippingTooltip:
      'Crea etiquetas de envío directamente desde los pedidos CSV de OrderCup.',
    getOrderResponseLog: 'Guardar registro de respuestas de pedidos',
    getOrderResponseLogTooltip:
      'Guarda los registros de respuesta de las importaciones para depuración y auditoría.',
    gdprShipStation: 'GDPR ShipStation',
    gdprShipStationTooltip:
      'Oculta el correo y la dirección de envío del cliente en las importaciones de ShipStation. Hoy solo la importación nueva de ShipStation lo aplica.',
    uniqueShopifyImport: 'Importación única de Shopify',
    uniqueShopifyImportTooltip:
      'Evita que empiece una segunda importación de pedidos de Shopify mientras ya hay una en curso, para que los pedidos no se importen dos veces.',
    showOriginatingStoreId: 'Mostrar ID de la tienda de origen',
    showOriginatingStoreIdTooltip:
      'Muestra el ID de la tienda de origen en los pedidos, para centros de fulfillment con varias tiendas.',
    enableMultiShipment: 'Activar envíos múltiples',
    enableMultiShipmentTooltip:
      'Permite que un pedido se envíe en varios envíos, cada uno con su propia etiqueta.',
    enableReprintOption: 'Activar opción de reimpresión',
    enableReprintOptionTooltip:
      'Permite reimprimir etiquetas o comprobantes de empaque dentro de un periodo definido.',
    useShipStationV2Api: 'Usar la API V2 de ShipStation',
    useShipStationV2ApiTooltip:
      'Cambia esta cuenta a la API V2 más nueva de ShipStation. Las importaciones todavía no la usan.',
    logglyShipworksImport: 'Loggly: importación de ShipWorks',
    logglyShipworksImportTooltip:
      'Registra en Loggly las respuestas de pedidos de ShipWorks para depuración y monitoreo.',
    logglyShopifyImport: 'Loggly: importación de Shopify',
    logglyShopifyImportTooltip:
      'Registra en Loggly las respuestas de pedidos de Shopify para depuración y monitoreo.',
    logglyGpxPrintingLabel: 'Loggly: impresión de etiquetas en GPX',
    logglyGpxPrintingLabelTooltip:
      'Registra en Loggly los eventos de impresión de etiquetas de GPX.',
    logglyShippingEasyImport: 'Loggly: importación de ShippingEasy',
    logglyShippingEasyImportTooltip:
      'Registra en Loggly las respuestas de pedidos de ShippingEasy.',
    logglyShipStationImport: 'Loggly: importación de ShipStation',
    logglyShipStationImportTooltip:
      'Registra en Loggly las respuestas de pedidos de ShipStation.',
    logglyVeeqoImport: 'Loggly: importación de Veeqo',
    logglyVeeqoImportTooltip:
      'Registra en Loggly las respuestas de pedidos de Veeqo.',
    logglyGpxOrderScan: 'Loggly: escaneo de pedidos en GPX',
    logglyGpxOrderScanTooltip:
      'Registra en Loggly los eventos de escaneo de pedidos de GPX.',
    logglyGpScannedTag: 'Loggly: etiqueta escaneada en GP',
    logglyGpScannedTagTooltip:
      'Registra en Loggly los eventos de etiquetas escaneadas de GroovePacker.',
    logglyProductInventoryTrack:
      'Loggly: seguimiento de inventario de productos',
    logglyProductInventoryTrackTooltip:
      'Registra en Loggly los eventos de seguimiento de inventario de productos.',
    inventoryPushBigCommerce: 'BigCommerce',
    inventoryPushBigCommerceTooltip:
      'Envía automáticamente las cantidades de inventario a BigCommerce.',
    inventoryPushShopify: 'Shopify',
    inventoryPushShopifyTooltip:
      'Envía automáticamente las cantidades de inventario a Shopify.',
    inventoryPushShopline: 'Shopline',
    inventoryPushShoplineTooltip:
      'Envía automáticamente las cantidades de inventario a Shopline.',
    inventoryPushMagento2: 'Magento 2',
    inventoryPushMagento2Tooltip:
      'Envía automáticamente las cantidades de inventario a Magento 2.',
    inventoryPushTeapplix: 'Teapplix',
    inventoryPushTeapplixTooltip:
      'Envía automáticamente las cantidades de inventario a Teapplix.',
    regularUsers: 'Usuarios regulares',
    regularUsersTooltip:
      'Máximo de usuarios regulares que puede tener esta cuenta. Los usuarios regulares empacan y escanean, y tanto los activos como los inactivos cuentan para este límite, pero los eliminados no.',
    adminOnlyUsers: 'Usuarios solo administrativos',
    adminOnlyUsersTooltip:
      'Máximo de usuarios solo administrativos que puede tener esta cuenta. Inician sesión para administrar la cuenta pero no empacan, y se cuentan aparte de los usuarios regulares.',
    shipmentsPerMonth: 'Envíos por mes',
    shipmentsPerMonthTooltip: 'Envíos incluidos en el plan cada mes.',
    deleteOrdersAfterDays: 'Eliminar pedidos después de (días)',
    deleteOrdersAfterDaysTooltip:
      'Los pedidos con más días que este número se eliminan automáticamente.'
  },
  recordTracingmsg: {
    createShippingLabel:
      'Por favor, cree la etiqueta de envío, adhiérala al paquete y escanee el número de seguimiento para continuar.'
  },
  shippinglabelmsg: {
    scanShippingLabel:
      'Por favor, escanee el código de barras de la etiqueta de envío para continuar.',
    noRecordTracking:
      'Este pedido no tiene un número de seguimiento asociado. Puede haberse importado antes de que se generara la etiqueta de envío. Haga clic o presione Enter para omitir esta verificación y marcar el pedido como escaneado.'
  },
  orderConfirmationPopup: {
    orderConfirmationMismatch:
      'Este código de confirmación no parece ser válido. Los códigos de confirmación se pueden actualizar en la página del usuario en la sección de configuración.',
    orderConfirmationText: 'Se requiere confirmación para esta nota:',
    orderConfimationEnterScan:
      'Ingrese o escanee su código de confirmación para continuar.',
    orderConfirmationTextBedoreInput:
      'Por favor, confirme que ha visto la nota ingresando su código de confirmación.'
  },
  productConfirmationPopup: {
    productConfirmationTest:
      'Por favor, confirme que se siguieron las siguientes instrucciones del producto ingresando su código de confirmación.',
    productConfirmationEnterScan:
      'Ingrese o escanee su código de confirmación para continuar',
    productConfirmationAlert:
      'Este código de confirmación no parece ser válido. Los códigos de confirmación se pueden actualizar en la página del usuario en la sección de configuración.',
    inputPlaceHolder: 'Ingrese el código de confirmación para continuar',
    productInstruction: 'Instrucciones del producto para'
  },
  serialRecord: {
    serial_number:
      'Escanee o ingrese el número de serie, lote o número de lote',
    serial_number_two:
      'Escanee o ingrese el número de serie, lote o número de lote 2'
  },
  wmsLotVerification: {
    confirmationCodeMessage:
      'Escanee o ingrese su código de confirmación para verificar este lote',
    lotNumberMessage: 'Escanee o ingrese el número de lote: {{lot}}',
    confirmationCodeError: 'Ese código de confirmación no fue reconocido.',
    lotNumberError:
      'Ese no es el número de lote de este artículo. Escanee o ingrese el lote mostrado.'
  },
  wmsZeroInventory: {
    authorizedByMessage: '{{message}} (Autorizado por: {{authorizedBy}})',
    lotRequiredError: 'Ingrese un número de lote.',
    qtyRequiredError: 'Ingrese una cantidad de al menos 1.',
    passButton: 'Aprobar'
  },
  scanPack: {
    settingUpdateFailed:
      'No se pudo actualizar la configuración. Inténtalo de nuevo.',
    already_scanned: 'El pedido ya ha sido escaneado.',
    permissionDeniedTitle: 'Permiso denegado',
    permissionDeniedMessage:
      'Los usuarios administrativos no tienen permiso para escanear pedidos.',
    already_cancelled: 'Este pedido ha sido cancelado y no se puede escanear.',
    scanned_one_pass: 'El pedido ha sido marcado como escaneado.',
    packing_slip: 'Escanee un comprobante de empaque',
    shippingLable_or_packingSlip:
      'Escanee un comprobante de empaque o una etiqueta de envío',
    shippingLable: 'Escanee una etiqueta de envío',
    assignOrderTooltip:
      'Al hacer clic en el botón Asignar Pedidos, los pedidos se asignarán al usuario que lo haya presionado. Los pedidos se asignarán desde la lista de prioridades en orden de mayor a menor prioridad, según tu configuración. La cantidad de pedidos asignados se determina según la configuración del botón.',
    empty_order:
      'No se encontraron artículos en este pedido. Si esto no es lo esperado, intente eliminar y volver a importar el pedido. Si el problema persiste, comuníquese con el soporte.',
    quickScanTollTip: `Haga clic en el botón Escaneo Rápido o escanee un código de barras con el
                      valor QUICKSCAN para mostrar automáticamente el pedido no escaneado más antiguo para su verificación.`,
    noOrderPresent: 'No se encontraron pedidos en la lista de pendientes.',
    alreadyScanned: 'Este pedido ya ha sido escaneado',
    howToProceed: '¿Cómo le gustaría proceder?',
    rePrint: 'Reimprimir etiqueta de envío',
    reScan: 'Reescanear este pedido',
    alreadyScannedMessage: 'El pedido {{orderNumber}} ya ha sido escaneado.',
    inputPlaceHolder: 'Listo para escanear pedido',
    scanLabel: 'Escanear',
    quickScanLabel: 'Escaneo rápido',
    importLabel: 'Importar ahora',
    importStatusLabel: 'Verificar estado de importación',
    rfoTitle:
      'Escanee el comprobante de empaque de un pedido que desea empacar.',
    checkInternet: 'Por favor, verifique su conexión a internet',
    onDemandRequested:
      'Estamos solicitando ese pedido y se abrirá en cuanto esté disponible. Si no desea esperar, puede escanear otro número de pedido.',
    onDemandCancel: 'Cancelar',
    importStatus: {
      status: 'Estado de importación',
      last: 'Último',
      current: 'Actual',
      processed: 'Pedidos procesados',
      remaining: 'Pedidos restantes',
      elapsedTime: 'Tiempo transcurrido',
      timeRemaining: 'Tiempo restante',
      lastImport: 'Última importación completada'
    },
    shouldInventoryAdjust: '¿Se debe ajustar el inventario?',
    noReScanItems: 'No, los artículos anteriores se están reescaneando',
    yesPullInventory: 'Sí, se sacaron nuevos artículos del inventario',
    noDataAvailable: 'No hay datos disponibles',
    lastImportLabel: 'La última importación fue',
    importStartedLabel: 'La última importación comenzó',
    ago: 'hace',
    estimatedTime: 'Tiempo estimado restante',
    hoursForStore: 'segundos por tienda',
    minutesForStore: 'minutos por tienda',
    secondsForStore: 'segundos por tienda',
    calculateEstimate: 'Calculando tiempo estimado restante',
    hours: 'horas',
    minutes: 'minutos',
    headerLabel: 'Escanear y Verificar'
  },
  product: {
    images_remove:
      '¿Está seguro de que desea eliminar esta imagen del producto?',
    alias_of_another: 'Hacer que este producto sea un alias de otro',
    aliases_of_this_product: 'Elija productos que sean alias de este producto',
    kit_to_product: 'Cambiar este kit a un producto',
    product_to_kit: 'Cambiar este producto a un kit',
    product_not_found: 'No se puede encontrar el producto con el SKU',
    same_barcode_found: '¡Vaya! Este código de barras ya existe.',
    same_sku_found: '¡Vaya! Este SKU ya existe.',
    QOH: 'Cantidad en Existencia',
    location1: 'Ubicación 1',
    location2: 'Ubicación 2',
    location3: 'Ubicación 3',
    location_qty1: 'Cantidad en Ubicación 1',
    location_qty2: 'Cantidad en Ubicación 2',
    location_qty3: 'Cantidad en Ubicación 3',
    inventory_alert_level: 'Nivel de alerta de inventario',
    inventory_target_level: 'Nivel objetivo de inventario',
    product_name: 'Nombre del producto',
    skus: 'SKUs',
    barcodes: 'Códigos de barras',
    unique_bar: 'Escanee o ingrese un código de barras único',
    unique_sku: 'Escanee o ingrese un SKU único',
    scan_qty: 'Cantidad escaneada',
    categories: 'Categorías',
    fnsku: 'FNSKU',
    asin: 'ASIN',
    isbn: 'ISBN',
    ean: 'EAN',
    supplier_sku: 'SKU del proveedor',
    avg_cost: 'Costo promedio',
    count_group: 'Grupo de conteo',
    product_weight: 'Peso del producto',
    product_length: 'Longitud',
    product_width: 'Ancho',
    product_height: 'Altura',
    product_dimension_unit: 'Unidades de dimensión del producto',
    // scan & pack option text
    click_scan: 'Omitir / escaneo por clic',
    type_count: 'Conteo manual',
    record_serial: 'Registrar número de serie / lote',
    record_type_label_1: 'Valor 1:',
    record_type_label_2: 'Valor 2:',
    record_type_serial: 'Serie',
    record_type_lot: 'Lote',
    intangible_item: 'Artículo intangible',
    add_any_order: 'Agregar a cualquier pedido',
    optional_item: 'Artículo opcional / omitible',
    packing_ins: 'Instrucciones de empaque',
    require_conf: 'Requiere confirmación',
    scanning_seq: 'Anular secuencia de escaneo',
    custom_prod1: 'Producto personalizado 1',
    custom_prod2: 'Producto personalizado 2',
    custom_prod3: 'Producto personalizado 3',
    display: 'Mostrar',
    aliasOfAnotherMessage: '¿Está seguro? ¡Esto no se puede deshacer!',
    click_scan_tooltip:
      'Los artículos con códigos de barras dañados o faltantes pueden ser omitidos usando el botón Omitir si está habilitado. La opción puede deshabilitarse para artículos que no deben omitirse. "Con confirmación" requerirá que un usuario con permiso de omisión proporcione su código de confirmación. "Con mensaje" permitirá la omisión, pero se mostrará un mensaje desalentando su uso.',
    type_count_tooltip:
      'Cuando está habilitado, esta configuración permite escanear un artículo y luego ingresar manualmente una cantidad en lugar de escanear cada artículo uno por uno. Es ideal cuando tiene muchos artículos precontados en cajas. Puede configurar el desencadenante de entrada en la configuración de escaneo y empaque.',
    record_serial_tooltip:
      'Cuando está habilitado, se le pedirá al empacador que escanee un número de serie cada vez que se empaquete este producto. El número de serie registrado se puede ver en el registro de actividad del pedido o descargar en el archivo CSV de series del pedido.',
    intangible_item_tooltip:
      'Los artículos intangibles, también conocidos como artículos transaccionales, son artículos no físicos que no necesitan ser empacados. Ejemplos incluyen códigos de cupones, seguros, cargos por manejo el mismo día, etc.',
    add_any_order_tooltip:
      'Cuando esta opción está habilitada para un producto, puede agregarlo a cualquier pedido que esté empacando solo con escanearlo. Esto es excelente para rastrear el inventario de cajas o bolsas decididas en el momento del empaque.',
    optional_item_tooltip:
      'A diferencia de la opción "Omitir", esta configuración se habilita solo para artículos no esenciales como obsequios o cupones, los cuales pueden omitirse si no hay existencias.',
    packing_ins_tooltip:
      'El texto de las instrucciones de empaque se mostrará cada vez que se sugiera este artículo para escanear. Habilitar la opción de confirmación requerida solicitará al usuario que escanee o ingrese su código de confirmación.',
    scanning_seq_tooltip:
      'La secuencia sugerida de escaneo se determina automáticamente por la ubicación principal del artículo o SKU. Puede anular esta secuencia configurando valores personalizados.',
    custom_prod1_tooltip:
      'Los datos personalizados del producto se pueden ingresar aquí o importar usando el archivo CSV. Esta información se puede mostrar cuando el artículo es sugerido para escanear.',
    scanRecordCountText:
      'Se requiere confirmación para esta acción.\nPor favor, escanee o ingrese su código de confirmación para continuar.',
    scanRecordErrorText:
      'El código de confirmación proporcionado no es válido. Inténtelo de nuevo.',
    zeroBarcodeText:
      'Los artículos "Nuevos" cambiarán automáticamente a "Activos" cuando se agregue su código de barras. No es posible cambiar el estado manualmente.',
    address_new_items: 'Cómo manejar los artículos "Nuevos"',
    // Kit options text
    kit_scanning: 'Opciones de escaneo de kits',
    alertBoxMultiBox:
      'Por favor, escanee los artículos en la caja actual antes de crear otra caja.',
    alertBoxChampPlanned:
      'Este pedido está planificado por BoxChamp. Las cajas se agregan automáticamente a medida que se empacan los artículos.',
    alertBoxEmptyBoxPrint:
      'Por favor, escanee los artículos en la caja antes de imprimir una hoja de empaque.',
    alertPrintSlipFailed: 'La hoja de empaque no se imprimió. Inténtelo de nuevo.',
    alertBoxPermission:
      'Por favor, comuníquese con un miembro del equipo y solicite permisos de edición antes de realizar cambios.',
    alertBoxOrderInProgress:
      'No se puede actualizar. El pedido está actualmente en proceso y está asignado a un carrito.',
    alertBoxSaveData: 'Los datos del producto se han actualizado',
    scanToCartEditRestriction:
      'Las actualizaciones de productos están deshabilitadas cuando se abre desde Escanear al Carrito.',
    status: 'Estado',
    prePackedKitItem: 'Los kits preempacados se escanean como un solo artículo',
    oneBarcodeKitItem: `- Se escanea un solo código de barras que representa todos los artículos del kit.`,
    kitParts: 'Los artículos del kit se escanean individualmente',
    singleKitItem: `- Los códigos de barras de los artículos individuales del kit siempre se escanean.`,
    singleKitBarcode: `- Se escanea un único código de barras del kit, a menos que no haya kits preempacados.`,
    kitPrePacked: `Los kits suelen estar preempacados.`,
    pickerSelectedOptions: {
      one: `1 - Los kits preempacados se escanean como un solo artículo`,
      two: `2 - Los artículos individuales del kit se escanean individualmente`,
      three: `3 - Los kits suelen estar preempacados`
    }
  },
  directprinting: {
    printPackingSlip: 'Imprimir albarán',
    printingPackingSlip: 'Imprimiendo albarán…',
    soundSettings: 'Administrar la configuración de sonido',
    saveLabel: 'Ahorrar',
    soundSettingLabel: 'Configuración de sonido',
    enterNumberOfSeconds: 'Número de segundos',
    slideShow: 'Tiempo de presentación de diapositivas',
    selectSoundSetting: 'Seleccionar configuración de sonido', // <-- Add this line
    enableCorrectScanFeedback:
      'Habilitar retroalimentación de escaneo correcto',
    errorScanFeedback: 'Retroalimentación de error de escaneo',
    orderDoneFeedback: 'Retroalimentación de pedido completado',
    default: 'Predeterminado',
    selectprinter:
      'Por favor, elija la impresora que desea usar para trabajos de este tipo.',
    directprintingHead: 'Configuración de impresión directa',
    otherOptions: 'Otras opciones',
    packingslipSetting: 'Comprobantes de empaque y trabajos de impresión',
    productBarcode: 'Código de barras del número de pedido',
    shippiglabel: 'Etiquetas de envío mediante API',
    ordernumberbarcode: 'Etiquetas de código de barras del producto',
    hapticsLable: 'Retroalimentación háptica',
    suppressSoftwareKeyboard: 'Ocultar el teclado en pantalla',
    suppressSoftwareKeyboardTooltip:
      'Cuando está activado, el teclado en pantalla no aparecerá al enfocar el campo de escaneo. Úselo con un escáner de códigos de barras externo Bluetooth o USB para que la interfaz de escaneo permanezca visible. Desactívelo si necesita escribir códigos de barras manualmente.',
    receiveRecountLabel: 'Etiquetas de recepción de productos',
    alertForPdfSizeEdit:
      'La entrada no es editable en GPX. Puede editar el tamaño del PDF desde la aplicación anterior.',
    packingsliptolltipOne:
      'La impresión directa utiliza una aplicación instalada en su Mac o PC para enviar trabajos de impresión directamente a su impresora en lugar de abrirlos en una pestaña del navegador.',
    packingsliptolltipLinkText: 'Este artículo de la base de conocimientos',
    printerSizeSelectionText:
      'Por favor, seleccione el tamaño de impresión y luego elija un archivo.',
    packingsliptolltipTwo:
      ' lo explica en detalle. Cada usuario puede configurar una impresora para cada tipo de trabajo que se utilizará al imprimir. El botón Restablecer se puede usar para borrar todas las asociaciones de impresoras.',
    productbarcodetolltip:
      'Las etiquetas de código de barras del producto se pueden imprimir desde varias áreas en la aplicación GPX. Cuando está habilitado, se enviarán directamente a la impresora.',
    shippinglabeltolltip:
      'GroovePacker puede generar etiquetas de envío usando la API de etiquetas de algunos gestores de pedidos. Cuando está habilitado, estas etiquetas se enviarán directamente a la impresora.',
    ordernumbertolltip:
      'Una etiqueta pequeña que contiene solo el nombre del cliente y el número de pedido se puede imprimir automáticamente después de escanear cada pedido. Cuando está habilitado, esta etiqueta se enviará directamente a la impresora.',
    tooltippacking:
      'Los comprobantes de empaque se pueden imprimir manualmente o automáticamente. Habilite este interruptor para enviar los comprobantes directamente a la impresora.',
    tooltipBarcode:
      'Las etiquetas de código de barras del producto se pueden imprimir desde varias áreas en la aplicación GPX. Cuando está habilitado, se enviarán directamente a la impresora.',
    tooltipShipping:
      'GroovePacker puede generar etiquetas de envío usando la API de etiquetas de algunos gestores de pedidos. Cuando está habilitado, estas etiquetas se enviarán directamente a la impresora.',
    tooltipOrderBarcode:
      'Una etiqueta pequeña que contiene solo el nombre del cliente y el número de pedido se puede imprimir automáticamente después de escanear cada pedido. Cuando está habilitado, esta etiqueta se enviará directamente a la impresora.',
    tooltipHaptics:
      'Cuando está habilitado, los dispositivos Android vibrarán para confirmar los escaneos y algunas operaciones.',
    tooltipDirectPrintinHeading:
      'La impresión directa utiliza una aplicación instalada en su Mac o PC para enviar trabajos de impresión directamente a su impresora en lugar de abrirlos en una pestaña del navegador. Este artículo de la base de conocimientos lo explica en detalle. Cada usuario puede configurar una impresora para cada tipo de trabajo. El botón Restablecer se puede usar para borrar todas las asociaciones de impresoras.',
    tooltipSoundSetting:
      'Selecciona cualquier tipo y sube el archivo al que deseas agregar sonido. ',
    tooltipReceivingPrinting:
      'Las etiquetas de recepción de productos se utilizan para etiquetar cajas de inventario adicional para que puedan identificarse y escanearse fácilmente. Este interruptor habilita la opción de impresión directa para estas etiquetas.',
    tooltipWeights:
      'Puede ingresar pesos en unidades métricas o inglesas. Para el sistema inglés, el peso se puede ingresar usando una combinación de libras y onzas o solo onzas. Para el sistema métrico, el peso se puede ingresar usando una combinación de kilogramos y gramos o solo gramos.',
    tooltipResidential:
      'UPS requiere que un envío sea designado como Residencial si se envía a una dirección residencial o Comercial si se envía a una dirección comercial.',
    alertForPdfLimit:
      'Ha alcanzado el límite diario de selecciones de archivos o el tamaño del archivo supera los 40 MB.',
    alertForNoPrinter:
      'No hay impresoras disponibles. Para imprimir desde el navegador, desactive la impresión directa.',
    confirmAgainPrinting:
      '¿Está seguro? \n Parece que este archivo ya pudo haberse impreso.',
    pdfMovedNotification:
      'Después de imprimir, el PDF se moverá a la pestaña de impresos.',
    // printComplete: "Archivo impreso usando QZ"
    selectLanguage: 'Seleccionar idioma',
    english: 'Inglés',
    spanish: 'Español'
  },
  clearFilterPrompt: {
    clearFiltersText:
      'Ningún pedido en la vista actual coincide con su búsqueda.',
    clearFiltersBtnText:
      'Haga clic aquí para borrar los filtros y expandir su búsqueda a todos los pedidos en GroovePacker.'
  },
  filters: {
    include: 'Incluir',
    exclude: 'No incluir',
    all: 'Todos',
    any: 'Cualquiera'
  },
  packingCamDetail: {
    enterEmail:
      'Por favor, agregue una dirección de correo electrónico a continuación para habilitar las opciones de la cámara de empaque.',
    placeholder: 'Ingrese dirección de correo electrónico',
    emailSentPopup: 'Correo electrónico enviado con éxito',
    failToUpload: 'Error al subir la imagen, inténtelo de nuevo',
    uploadComplete: 'Carga completada',
    uploading: 'Cargando...',
    escTollTip: 'ESC para cancelar',
    spaceBarTollTip: 'BARRA ESPACIADORA para volver a tomar',
    enterTollTip: 'ENTER para confirmar',
    cancelLabel: 'Cancelar',
    retakeLabel: 'Volver a tomar',
    confirmLabel: 'Confirmar'
  },
  reprintText: {
    reprintNotAllowHeading:
      'Fueron compradas en el gestor de pedidos y deben ser reimpresas allí.',
    previousPurchaseLabelHeading: 'Etiquetas previamente compradas encontradas',
    canBeReprintHeading:
      'Las etiquetas impresas anteriormente pueden ser reimpresas a continuación',
    canBeReprintSubHead: 'Haga clic en una etiqueta para reimprimirla.'
  },
  order: {
    internal_notes: 'Notas internas',
    notes_to_packer: 'Notas para el empacador',
    customer_comments: 'Comentarios del cliente',
    tags: 'Etiquetas',
    notes_from_packer: 'Notas del empacador',
    internal_notes_tooltip:
      'Las notas internas se pueden importar desde la fuente del pedido. Por ejemplo, si agrega una nota a un pedido en ShipStation o ShippingEasy, se puede importar y guardar en este campo. La importación de notas internas se controla en la configuración de cada tienda. Una vez importadas, una opción en la configuración de escaneo y empaque determina si la nota se mostrará al empacador.',
    notes_to_packer_tooltip:
      'Si las notas para el empacador se agregan directamente en GroovePacker, este campo debe usarse. Todo lo que se guarde aquí siempre se mostrará durante el escaneo.',
    customer_comments_tooltip:
      'Con algunas integraciones, los comentarios del cliente se pueden importar a este campo y mostrarse opcionalmente durante el escaneo. Una vez importados, una opción en la configuración de escaneo y empaque determina si los comentarios del cliente se mostrarán al empacador.',
    tags_tooltip:
      'Las etiquetas de pedido de Shopify se pueden importar a este campo y mostrarse opcionalmente durante el escaneo. Una vez importadas, una opción en la configuración de escaneo y empaque determina si las etiquetas se mostrarán al empacador.',
    notes_from_packer_tooltip:
      'Una nota agregada al pedido durante el proceso de escaneo se mostrará aquí. La nota también se puede enviar automáticamente por correo electrónico a la dirección de notificaciones especificada en la configuración del sistema. La nota se puede agregar durante el escaneo usando el botón "Agregar nota" o escaneando el código de acción: NOTA. Este código de barras se puede imprimir desde la sección de configuración de Escanear y Empacar.',
    order_number: 'Número de pedido',
    scanning_completed: 'Escaneo completado',
    order_date: 'Fecha del pedido',
    tracking_number: 'Número de seguimiento',
    customer_order_data1: 'Datos del pedido del cliente 1',
    customer_order_data2: 'Datos del pedido del cliente 2',
    first_name: 'Nombre',
    last_name: 'Apellido',
    email: 'Correo electrónico',
    company: 'Empresa',
    city: 'Ciudad',
    state: 'Estado',
    address_1: 'Dirección 1',
    address_2: 'Dirección 2',
    postal_code: 'Código postal',
    country: 'País',
    addKitToKitMessage:
      '¿Le gustaría agregar los artículos de kit del kit {{childKit}} como artículos del kit {{parentKit}}?',
    kitItemTolltip:
      'Busque los artículos del kit que desea agregar ingresando el nombre, el SKU o escaneando el código de barras. Haga clic en un artículo para seleccionarlo. Se pueden realizar múltiples búsquedas y selecciones antes de guardar para agregar varios artículos al mismo tiempo.',
    inventoryKitTollTip:
      'Los kits preempacados se escanean como un solo artículo - Se escanea un código de barras que representa todos los artículos del kit. Esto permite el seguimiento del inventario de las partes del kit. Los artículos individuales del kit se escanean uno por uno - Los códigos de barras de los artículos individuales siempre se escanean. Los kits suelen estar preempacados - Se escanea un único código de barras del kit a menos que no haya kits preempacados.',
    productSearchListTooltip:
      'Escanee o ingrese el código de barras de un artículo para abrirlo directamente. La búsqueda con el SKU exacto también abrirá el artículo directamente. Las coincidencias parciales se mostrarán en una lista.',
    addItemToOrderError:
      'Por favor, cambie el estado de este producto/kit a Activo antes de agregarlo al pedido.',
    addItemToOrderTollTip:
      'Se pueden agregar varios artículos a un pedido al mismo tiempo. Después de buscar un artículo por su nombre, SKU o código de barras, use la casilla de verificación para seleccionarlo. Se pueden realizar selecciones adicionales de la misma manera. Una vez seleccionados todos los artículos necesarios, haga clic en "Guardar y cerrar" para agregarlos al pedido.',
    multiBoxTollTip:
      'El menú desplegable le permite seleccionar si el comprobante de empaque se imprimirá para la caja seleccionada actualmente (en la tabla a continuación) o si se imprimirán los comprobantes de empaque para todas las cajas. Haga clic en el ícono de la impresora para iniciar la impresión.',
    orderNotFound:
      'El número de pedido proporcionado no se encontró. Es posible que el pedido correspondiente aún no se haya importado.',
    selectedUserError:
      'Por favor, seleccione múltiples pedidos para asignar o eliminar.',
    noSelectedUserError:
      'Por favor, seleccione pedidos o usuarios para asignar o eliminar.',
    cartPreviewFailed:
      'No se pudo comprobar si estos pedidos están en un carrito. El estado no se cambió.',
    cartRemovalTitle: '¿Está seguro?',
    cartRemovalConfirm: 'Cambiar estado',
    cartRemovalCancel: 'Cancelar',
    cartRemovalSingleOrder:
      'Este pedido está en el carrito {{cart}}. Al cambiar su estado se retira del carrito. Los demás pedidos permanecen en el carrito.',
    cartRemovalSingleOrderNoLabel:
      'Este pedido está en un carrito. Al cambiar su estado se retira del carrito. Los demás pedidos permanecen en el carrito.',
    cartRemovalOneOrder: '1 de estos pedidos está en un carrito y se retirará de él.',
    cartRemovalManyOrders:
      '{{count}} de estos pedidos están en carritos y se retirarán de ellos.',
    statusUpdateFailed:
      'No se pudo actualizar el estado del pedido. Por favor, inténtelo de nuevo.',
    quantityUpdateFailed:
      'No se pudo actualizar la cantidad del artículo. Por favor, inténtelo de nuevo.',
    clearAllAssignmentLabel: 'Borrar todas las asignaciones',
    clearAllAssignmentMessage:
      '¿Está seguro de que desea borrar todas las asignaciones?',
    createOrder: 'Crear Pedido',
    cameraPermissionMessage:
      'Packing cam necesita acceso a la cámara. Habilite los permisos de la cámara web en el navegador y luego haga clic en reintentar a continuación. Si no se usará el packing cam en esta estación de trabajo, desactívelo haciendo clic en desactivar a continuación.',
    disableButton: 'Desactivar',
    retryButton: 'Reintentar'
  },
  tagPriority: {
    createPriorityCardText:
      'Los pedidos con esta prioridad se identificarán con la siguiente etiqueta:'
  },
  awaitingWindow: {
    title: 'Ventana de Pedidos en Espera',
    daysLabel: 'Días',
    tooltip:
      'La ventana de filtrado de fechas establecida aquí se utiliza para la vista de filtrado predeterminada de la lista de pedidos. No afecta la asignación de pedidos: los pedidos de cualquier antigüedad permanecen disponibles para ser asignados a los usuarios.',
    saveButton: 'Guardar y Cerrar',
    invalidDaysError: 'Por favor ingrese un número válido de días mayor que 0',
    saveError:
      'No se pudo guardar la configuración. Por favor, inténtelo de nuevo.'
  },
  activityException: {
    alerts: {
      exceptionRecorded: 'Excepción registrada exitosamente',
      exceptionMissingReason:
        'No se puede registrar la excepción sin una razón',
      exceptionCleared: 'Registro de excepción eliminado',
      noExceptionToClear: 'El pedido no tiene ninguna excepción que eliminar'
    },
    headers: {
      activityLog: 'Registro de actividad',
      packingExceptions: 'Excepciones de empaque',
      exceptionType: 'Tipo de excepción',
      description: 'Descripción',
      associatedWith: 'Asociado con la excepción'
    },
    buttons: {
      saveAsText: 'Guardar como texto',
      recordException: 'Registrar excepción',
      clearException: 'Eliminar excepción'
    }
  },
  addItemInBox: {
    addItemsTollTip: `Se pueden agregar varios artículos a un pedido al mismo tiempo. Después de buscar
              un artículo por su nombre, SKU o código de barras, use la casilla de
              verificación para seleccionarlo. Se pueden realizar selecciones adicionales de la misma manera. Una vez
              que se seleccionen todos los artículos necesarios, haga clic en "Guardar y cerrar" para agregarlos
              al pedido.`
  },
  shipmentRecord: {
    additionalShipments: 'Envíos adicionales asociados con este pedido',
    shipmentWarning:
      'Uno de los envíos asociados con este pedido fue escaneado en GroovePacker y luego combinado en ShippingEasy. En lugar de modificar un pedido que ya ha sido escaneado, le informamos para que pueda tomar las acciones necesarias.',
    acknowledgeAndContinue:
      'Una vez que se eliminen todos los envíos no deseados, puede hacer clic aquí para confirmar y continuar.'
  },
  copiedText: {
    copiedCartId: 'ID de carrito "{{cartId}}" copiado al portapapeles!',
    copiedToteId: 'Tote "{{toteId}}" copiado al portapapeles!'
  },
  productFirst: {
    claimHeading: 'Escanee uno de sus {{toteIdentifier}}(s) para comenzar.',
    claimPlaceholder: 'Escanee un código de barras de {{toteIdentifier}}',
    scanProductPlaceholder: 'Escanee un código de barras de producto',
    scanTotePlaceholder:
      'Ingrese o escanee el código de barras de {{toteIdentifier}}',
    scanProductPrompt: 'Escanee un producto para comenzar.',
    orderAssigned:
      'El pedido {{orderNumber}} está asignado a {{toteIdentifier}} {{toteName}}',
    unscannedTitle: '{{count}} artículos sin escanear',
    itemsInToteTitle: '{{count}} artículos en {{toteIdentifier}}',
    bannerScan: 'Escanee {{toteIdentifier}} {{toteName}}',
    bannerPlaceEmpty: 'Por favor coloque en {{toteIdentifier}} {{toteName}}',
    bannerPlaceOccupied:
      'Por favor coloque en {{toteIdentifier}} ocupado {{toteName}}',
    bannerCollect:
      'Escanee y recoja {{toteIdentifier}} {{toteName}} para finalizar el pedido.',
    orderComplete: '¡Pedido completado!',
    stateEmpty: 'Vacío',
    stateOccupied: 'Ocupado',
    stateCollect: 'Recoger',
    invalidTote: 'Escanee un código de barras de {{toteIdentifier}} válido.',
    wrongTote:
      '¡Vaya! Ese {{toteIdentifier}} es incorrecto. Escanee el {{toteIdentifier}} correcto y luego agregue el artículo.',
    scanFailed: 'Error al escanear. Inténtelo de nuevo.',
    restartOrder: 'Reiniciar pedido',
    removeItem: 'Eliminar artículo',
    removeFirst: 'Eliminar',
    removeSecond: 'Artículo',
    addNote: 'Agregar nota',
    restartConfirm:
      '¿Reiniciar este pedido? Se borrará su asignación de {{toteIdentifier}}.',
    removeConfirm: '¿Eliminar este artículo del pedido?',
    addNotePlaceholder: 'Ingrese una nota para este pedido',
    toteSetButton: '{{toteIdentifier}} Set {{name}}',
    switchToteSet: 'Cambiar conjunto de {{toteIdentifier}}',
    progressPlaced: '{{count}} de {{total}} artículos escaneados y colocados',
    progressLeftHint:
      'Los artículos mostrados a la izquierda completan este pedido.',
    scanToContinue: 'Escanee cualquier producto disponible para continuar.'
  },
  scanToCart: {
    barcodeAssignedToOtherProduct:
      'Este código de barras ya está asignado a otro producto.',
    addBarcodeFailed:
      'No se pudo guardar el código de barras. Inténtelo de nuevo.',
    toteFullScanNext: 'Este artículo ya está en su tote. Escanee el siguiente artículo mostrado.',
    toteFullNoOtherLine: 'Este artículo ya está en su tote y no se puede escanear de nuevo. Reinicie el carrito o consulte a un supervisor.',
    tollTip: `Si los pedidos necesitan asignarse a un tote específico, se pueden etiquetar con el ID de tote correspondiente. Por ejemplo, etiquetar un pedido con "A-1-C01" lo asignará al primer tote de la fila A del carrito 1. Haga clic en un tote a continuación para copiar su etiqueta de ID de tote al portapapeles.`,
    tollTipLabel: `Los pedidos etiquetados como "{{cartId}}" solo se asignarán a este carrito.`,
    addRowLabel: `Agregar una Fila`,
    addCartLabel: `Agregar un Carrito`,
    cartsLabel: 'Carritos',
    printToteLabel: 'Imprimir Etiquetas de Totes',
    rowIdLabel: 'ID de Fila',
    totesInRowLabel: 'Totes/Fila',
    dimensions: 'Dimensiones',
    saveChanges: 'Guardar cambios..',
    duplicateRow: 'fila duplicada',
    duplicateCart: 'Carrito duplicado',
    saveChanges: 'Guardar cambios..',
    okButtonLabel: 'Aceptar',
    cartUpdateError: 'Este carrito está actualmente en uso por pedidos activos y no se puede actualizar ni eliminar.',
    cartAssignedOrders: 'Este carrito tiene %{count} pedido(s) asignado(s), por lo que no se puede actualizar ni eliminar. Restablezca el carrito para quitarlos.',
    cartResetConfirm: 'Al restablecer se quitan estos pedidos del carrito y se deshace su progreso de recolección. ¿Continuar?',
    cartResetFailed: 'No se pudo restablecer el carrito. Inténtelo de nuevo.',
    resetCartButton: 'Restablecer carrito',
    cancelLabel: 'Cancelar',
    scanningCompleted: 'Escaneo del carrito completado',
    ConfirmReset: 'Sí, Reiniciar',
    CancelReset: 'No, Cancelar',
    includeActionRequiredOrders: 'Incluir Órdenes que Requieren Acción',
    includeActionRequiredOrdersTooltip:
      'Cuando está habilitado, los pedidos que contienen artículos "Nuevos" (artículos sin códigos de barras) se incluirán en los lotes. Si los recolectores tienen permiso para agregar códigos de barras para artículos nuevos durante el proceso de escaneo, este interruptor debe estar encendido. Si prefiere retener los pedidos y requerir que un administrador agregue códigos de barras de productos, el interruptor debe permanecer apagado.'
  },
  cartAssignment: {
    title:
      'Este carrito actualmente tiene pedidos asignados. ¿Cómo le gustaría continuar?',
    continueButton: 'Continuar recogiendo estos pedidos',
    continueProcessingButton: 'Continuar procesando estos pedidos',
    restartButton: 'Reiniciar los pedidos y vaciar el carrito',
    cancelButton: 'Cancelar y usar otro carrito',
    previouslyScanned: 'Este pedido fue escaneado anteriormente.',
    previouslyScannedDetails: 'Escaneado por {{username}} el {{timestamp}}',
    cartReadyForProcessing:
      '{{cartName}} listo para procesar. Escanee cualquiera de las bolsas ocupadas a continuación para continuar.',
    continueTooltip:
      'Tome la asignación de estos pedidos y continúe escaneándolos. Se mantendrá el progreso. Esta es una buena opción si el usuario que recoge este carrito se lo está entregando para que termine la recolección.',
    restartTooltip:
      'Todo el progreso en estos pedidos se perderá. Esta opción reiniciará y desasignará todos los pedidos en este carrito para un nuevo comienzo.\n\nAsegúrese de vaciar físicamente todas las bolsas en el carrito si elige esta opción.\n\nLos pedidos se reasignarán desde la lista de prioridades. Esta es una buena opción si no está seguro del estado de los pedidos en el carrito y preferiría comenzar una nueva recolección en lugar de continuar con esta.',
    cancelTooltip:
      'Elija "Cancelar" para dejar este carrito como está. Luego puede escanear un carrito diferente para continuar. Esta es una buena opción si el usuario asignado a este carrito reanudará la recolección más tarde.',
    processNowButton: 'Procesar ahora el pedido en este tote',
    processNowTooltip:
      'Normalmente los pedidos se procesan después de que se completa la recolección del carrito. Si escanea el tote de un pedido que ya está completamente recogido en un carrito parcialmente recogido puede usar esta opción para pasar directamente al paso de procesamiento de ese pedido en particular.',
    mixedResults:
      '{{failedCount}} Órdenes no pudieron ser asignadas - {{successCount}} Órdenes asignadas exitosamente a {{cartId}}.',
    failedOnly: '{{failedCount}} Órdenes no pudieron asignarse.',
    successOnly:
      '{{successCount}} Órdenes asignadas exitosamente a {{cartId}}.',
    viewDetails: 'Ver Detalles',
    noOrders: 'No se encontraron órdenes disponibles.',
    rfoNoOrders: 'No hay órdenes disponibles para asignar.',
    clickHere: 'Haga clic aquí',
    toRunImport: 'para ejecutar una importación.',
    awaitingOrders: 'Órdenes en espera de los últimos {{days}} días: {{count}}',
    closeToast: 'Cerrar',
    assignedToOthers: 'Órdenes asignadas a otros usuarios: {{count}}',
    taggedForOtherCart: 'Órdenes etiquetadas para otro carrito: {{count}}',
    availableForCart: 'Órdenes disponibles para este carrito: {{count}}',
    excludedByZone: '{{count}} órdenes excluidas por acceso de zona',
    emptyTotes: '{{count}} totes vacíos disponibles',
    issueDetails: {
      title: 'Issue Details',
      noIssues: 'No issues preventing assignment.',
      successTitle: 'Details of Successful tote assignments.',
      closeButton: 'Close and Continue'
    }
  },
  resumePicking: {
    title: '¿Le gustaría reanudar la recogida del carrito {{cartNumber}}?',
    continueButton: 'Sí, continuar con la recogida en curso',
    clearButton: 'No, borrar este carrito y empezar de nuevo',
    confirmationTitle:
      'Por favor, verifique que todas las bandejas estén vacías antes de continuar. Esto restablecerá todos los pedidos asignados al carrito.',
    cancelButton: 'Cancelar',
    confirmButton: 'Confirmar'
  },
  returnLater: {
    title: '¿Desea regresar a este artículo más tarde?',
    yesButton: 'Sí, regresar más tarde',
    noButton: 'No, omitir permanentemente'
  },
  stockIssue: {
    title: 'Reportar Problema de Inventario',
    replenishButton: 'Solicitar reabastecimiento de ubicación',
    replenishTooltip:
      'Envíe una solicitud para reabastecer esta ubicación. Puede continuar recogiendo otros artículos.',
    holdOrdersButton: 'Retener pedidos por falta de existencias',
    holdOrdersTooltip:
      'Marque este artículo como agotado y aparte su pedido. Los demás pedidos del carrito continúan.',
    cancelButton: 'Cancelar'
  },
  notFulfilledItems: {
    title: 'Los siguientes artículos no pudieron ser cumplidos:',
    scanButton: 'Escanear los artículos no cumplidos ahora',
    scanTooltip:
      'El artículo no cumplido fue encontrado en el almacén y los pedidos ahora pueden ser completamente procesados',
    removeButton: 'Remover el artículo no cumplido',
    removeTooltip:
      'Los artículos no cumplidos serán cancelados/reembolsados, otros artículos del pedido aún se enviarán. Se notificará al gerente/representante del cliente',
    serviceButton: 'Dejar como Problema de Servicio',
    serviceTooltip:
      'El pedido será marcado para procesamiento posterior por el equipo de servicio',
    cancelButton: 'Cancelar',
    putAwayButton: 'Guardar los artículos',
    putAwayTooltip:
      'Devuelva los artículos recogidos a sus ubicaciones. El pedido completo se volverá a recoger más adelante.',
    storeButton: 'Almacenar los artículos recogidos',
    storeTooltip:
      'Mantenga los artículos recogidos juntos y apártelos. Cuando llegue el inventario, solo será necesario escanear el artículo faltante.',
    backButton: 'Atrás',
    holdFailed:
      'No se pudo dejar el pedido como Problema de Servicio. Por favor, inténtelo de nuevo.',
    backorderButton: 'Pedido pendiente',
    backorderTooltip:
      'Este artículo quedará pendiente de pedido y se enviará más tarde, pero los demás artículos del pedido se enviarán hoy.',
    backorderFailed:
      'No se pudo poner el artículo en pedido pendiente. Por favor, inténtelo de nuevo.'
  },
  assignOrder: {
    assign: 'Asignar',
    orders: 'Órdenes',
    successMessage: 'Órdenes asignadas con éxito.',
    notAssignedMessage:
      'Parece que no hay pedidos no asignados y pendientes de los últimos 14 días.'
  },
  dashboard: {
    eachUserItemsByToday: `Total de artículos escaneados hoy.`,
    eachUserOrdersByToday: `Total de órdenes escaneadas hoy.`,
    eachUserItemsForToDay: `Artículos/min de cada usuario para hoy`,
    eachUserOrdersForToDay: `Órdenes/min de cada usuario para hoy`,
    eachUserItemsByDay: `Artículos por día durante 6 días`,
    eachUserOrdersByDay: `Órdenes por día durante 6 días`,
    itemsScannedByTime: `Artículos/min Ayer vs Hoy`,
    ordersScannedByTime: `Órdenes/min Ayer vs Hoy`,
    current15MinSession: `Total de artículos por usuario - Sesión actual de 15 min`,
    current15MinSessionOrders: `Total de órdenes por usuario - Sesión actual de 15 min`,
    itemsPerMinute: `Artículos/min (6 Días)`,
    ordersPerMinute: `Órdenes/min (6 Días)`,
    itemsPerHour: `Artículos por Hora`,
    ordersPerHour: `Órdenes por Hora`,
    scanScoreToday: `Puntuaciones altas de hoy`,
    dailyOrderGoal: `Meta de órdenes del día`,
    goalCompleted: `Completado`,
    goalRemaining: `Restante`,
    goalMet: `Meta alcanzada`,
    shiftDone: `Turno completado`,
    goalLabel: `Meta`,
    fullShift: `Turno completo`,
    shiftWorked: `Trabajado`,
    shiftStart: `Inicio`,
    shiftEnd: `Fin`,
    goalNoData: `No hay datos disponibles`,
    setProductionGoal: `Establecer la meta de producción de hoy`,
    updateProductionGoal: `Actualizar meta de producción`,
    updateGoalButton: `Actualizar meta`,
    goalSave: `Guardar`,
    goalCancel: `Cancelar`
  },
  verbosity: {
    noAnnouncement: 'Sin anuncios',
    locationOnly: 'Solo ubicación',
    locationAndQuantity: 'Ubicación y cantidad',
    skuLocationAndQuantity: 'SKU, ubicación y cantidad',
    locationAndTotalQuantity: 'Ubicación y cantidad total',
    skuLocationAndTotalQuantity: 'SKU, ubicación y cantidad total',
    tollTip:
      'La recolección por voz puede anunciar la información que ayuda en el proceso de pick & pack, para que pases menos tiempo leyendo la pantalla. Elige el nivel de verbosidad que mejor se adapte a ti. La configuración se guarda en el dispositivo.',
    label: 'Recolección por voz'
  },
  pickComplete: {
    congratulations: '¡Felicidades!',
    pickComplete: 'Recolección Completa',
    allCartsInProgress:
      'Todos los carritos parecen tener una recolección en progreso.',
    clearCartInstructions:
      'Si un carrito disponible necesita ser liberado, puedes escanear una de sus gavetas para reiniciar el carrito y así se puedan asignar órdenes.',
    newBatchInstructions:
      'Puedes comenzar a recolectar un nuevo lote escaneando cualquier gaveta en un carrito fresco y vacío:',
    processOrdersInstructions:
      'Para procesar las órdenes recolectadas en este carrito, por favor escanea cualquiera de las gavetas ocupadas.',
    processScanInstructions: 'Por favor, escanee uno de los totes resaltados.'
  },
  reversePickList: {
    buttonLabel: 'Lista de Selección Inversa',
    toastReversed: 'Lista de selección invertida',
    toastRestored: 'Orden de lista de selección restaurado'
  },
  productGrid: {
    deleteConfirmTitle: 'Confirmar Eliminación',
    deleteConfirmMessage:
      'Todas las órdenes con estos producto(s) serán puestas en espera. ¿Está seguro de que desea eliminar los productos seleccionados?',
    deleteConfirmYes: 'Sí, Eliminar',
    cancel: 'Cancelar',
    unknownAction: 'Acción desconocida',
    selectProducts: 'Por favor seleccione al menos un producto',
    deleteSuccess: 'Eliminación en cola exitosamente',
    duplicateSuccess: 'Duplicación en cola exitosamente',
    statusUpdateSuccess: 'Actualización de estado en cola exitosamente',
    generateBarcodeSuccess: 'Generación de código de barras en progreso',
    generateNumericBarcodeSuccess:
      'Generación de código de barras numérico en progreso',
    printBarcodeLabelsSuccess:
      'Las etiquetas de código de barras se generarán en breve',
    printReceivingLabelsSuccess:
      'Las etiquetas de recepción se generarán en breve',
    exportCsvSuccess:
      'Su solicitud ha sido puesta en cola. Recibirá un correo electrónico cuando la exportación de productos esté completa',
    brokenImageExportSuccess: 'En cola exitosamente',
    searchPlaceholder: 'Buscar productos por SKU, nombre o código de barras...',
    createProduct: 'Crear Producto'
  },
  duplicatePickWarning: {
    title: 'Advertencia de Selección Duplicada',
    message:
      'Si ves este mensaje mientras estás recogiendo, es muy probable que la etiqueta para este pedido haya sido impresa dos veces y esté en riesgo de ser enviada dos veces.',
    continueButton: 'Continuar, sé que es un reenvío',
    reportButton: 'Reportar Posible Selección Doble',
    question:
      '¿Estás realizando una segunda verificación (re-escaneando) para este y otros pedidos?',
    instructionPrefix: 'Si es así, puedes',
    instructionLink: 'hacer clic aquí',
    instructionSuffix: 'para silenciar las notificaciones para esta sesión.',
    activityLogAdded: 'Registro de actividad duplicada agregado',
    cancelButton: 'Cancelar'
  },
  zoneSettings: {
    title: 'Configuración de Zonas',
    zonesLabel: 'Zonas',
    addZoneLabel: 'Agregar una Zona',
    addRangeLabel: 'Agregar un Rango',
    rangeStartLabel: 'Inicio del Rango',
    rangeEndLabel: 'Fin del Rango',
    rangeStartPlaceholder: 'ej., A-1-1',
    rangeEndPlaceholder: 'ej., D-6-60',
    zoneNamePrefix: 'Zona',
    editZoneTooltip:
      'Las zonas son ubicaciones que están físicamente cerca unas de otras dentro del almacén. Idealmente, el volumen total de productos debería distribuirse de manera relativamente uniforme entre las zonas, en lugar de que la mayoría de los pedidos se recojan en una o dos zonas.',
    infoTooltip:
      'Agregue rangos de ubicación de contenedores para esta zona a continuación.',
    zoneAddedToast: 'Zona "{{zoneName}}" agregada exitosamente',
    zoneDeletedToast: 'Zona "{{zoneName}}" eliminada',
    rangeAddedToast: 'Rango agregado a {{zoneName}}',
    rangeDeletedToast: 'Rango eliminado de {{zoneName}}',
    saveSuccessToast: 'Configuración de zonas guardada exitosamente',
    saveError: 'Error al guardar la configuración de zonas',
    saveErrorToast: 'Error al guardar la configuración de zonas',
    zoneAddError: 'Error al agregar zona',
    zoneDeleteError: 'Error al eliminar zona',
    nameAlreadyTaken: 'El nombre de la zona ya está en uso'
  },
  savedFavouriteViews: {
    header: 'Vistas guardadas y favoritas',
    selectEdit: 'Seleccionar/Editar vistas guardadas',
    savedViews: 'Vistas guardadas',
    manageSavedViews: 'Administrar vistas guardadas',
    saveCurrentFilters: 'Guardar filtros actuales',
    savePromptMessage: 'Guardar filtros actuales como:',
    savePromptPlaceholder: 'Ingrese el nombre de la vista',
    manageModalTitle: 'Administrar vistas guardadas',
    save: 'Guardar',
    cancel: 'Cancelar',
    setAsFavourite: 'Marcar como favorita'
  },
  zoneAccess: {
    title: 'Acceso a Zonas',
    tooltip:
      'Las zonas Always On siempre se incluirán en la asignación de órdenes. Los usuarios tienen acceso a las zonas Opcionales y pueden habilitarlas y deshabilitarlas cuando solicitan órdenes para reducir la superposición de rutas. Las zonas Deshabilitadas son esencialmente restringidas, evitando que se asignen órdenes en estas zonas.',
    zone: 'Zona',
    zoneAccess: 'Acceso a Zonas',
    alwaysOn: 'Siempre Activado',
    optional: 'Opcional',
    disabled: 'Deshabilitado',
    saveAndClose: 'Guardar y Cerrar',
    assignmentPreference: 'Preferencia de asignación de zona:',
    assignmentPreferenceTooltip:
      'El acceso a zonas se puede ajustar para cada carrito para que solo se asignen órdenes de zonas seleccionadas al carrito.\n\nLa opción predeterminada es controlar el acceso a zonas por usuario para que los usuarios reciban órdenes de zonas específicas.',
    carts: 'Carritos',
    users: 'Usuarios',
    alwaysOnIntro: 'Las zonas ',
    alwaysOnDescription:
      ' siempre se incluirán en la asignación de órdenes. Los usuarios tienen acceso a las zonas ',
    optionalZonesLabel: 'Opcional',
    optionalZonesDescription:
      ' y pueden habilitarlas y deshabilitarlas cuando solicitan órdenes para reducir la superposición de rutas. Las zonas ',
    disabledZonesLabel: 'Deshabilitado',
    disabledZonesDescription:
      ' son esencialmente restringidas, evitando que se asignen órdenes en estas zonas.',
    unableToIdentifyEntity:
      'No se pudo identificar al usuario o al carrito. Inténtelo de nuevo.',
    specifyZoneAccess: 'Especifique el acceso a zonas para este carrito',
    cartOptionalZoneTitle: '{{cartName}} – Acceso a zonas opcionales',
    noOptionalZones: 'No hay zonas opcionales configuradas.'
  },
  unsavedChanges: {
    bannerMessage: 'Tienes cambios sin guardar',
    promptTitle: 'Tienes cambios sin guardar',
    promptMessage: '¿Guardar los cambios antes de salir de esta página?',
    save: 'Guardar',
    saving: 'Guardando…',
    discard: 'Descartar'
  },
  adminTenantGrid: {
    title: 'Cuentas',
    breadcrumbRoot: 'Admin Tools',
    duplicate: 'Duplicar',
    duplicateDisabledTooltip:
      'Seleccione una cuenta para duplicarla. Una cuenta eliminada debe restaurarse primero.',
    deleteDisabledTooltip:
      'Seleccione una cuenta para eliminarla. Una cuenta ya eliminada se puede restaurar.',
    oneAtATimeTooltip:
      'Esto funciona con una cuenta a la vez. Seleccione solo una para activarlo.',
    tenantCount: {one: '1 cuenta', other: '{{count}} cuentas'},
    activeCount: '{{count}} activas',
    deletedCount: '{{count}} eliminadas',
    loading: 'Cargando cuentas...',
    couldNotLoad: 'No se pudieron cargar las cuentas',
    matchCount: {one: '1 coincidencia', other: '{{count}} coincidencias'},
    searchPlaceholder: 'Buscar cuentas',
    statusActive: 'Activas',
    statusDeleted: 'Eliminadas',
    statusAll: 'Todas',
    allTenantSorting: 'Ordenar todas las cuentas',
    allTenantSortingTooltip:
      'Ordena las {{count}} cuentas, no solo esta página. Es más lento.',
    selectedCount: '{{count}} seleccionadas',
    delete: 'Eliminar',
    restore: 'Restaurar',
    restoreDisabledTooltip:
      'Solo se pueden restaurar cuentas eliminadas. Seleccione una cuenta eliminada para activar esta opción.',
    columns: 'Columnas',
    columnsShown: '{{shown}} de {{total}}',
    columnsMore: '+ {{count}} más',
    loadFailedBanner: 'No se pudieron cargar las cuentas. Inténtelo de nuevo.',
    retry: 'Reintentar',
    loadFailedTitle: 'No se pudieron cargar las cuentas',
    loadFailedBody:
      'El servidor no respondió ({{status}}). La lista no está vacía, solo no se cargó, y no se cambió nada. La última carga correcta fue a las {{time}}.',
    copyErrorDetails: 'Copiar detalles del error',
    emptyTitle: 'Ninguna cuenta coincide con "{{query}}"',
    emptyBody:
      'Ninguna de las {{count}} cuentas coincide con ese nombre, plan o tipo de tienda. Revise la ortografía o cambie el filtro de estado para incluir cuentas eliminadas.',
    clearSearch: 'Borrar búsqueda',
    pagerRange: '{{from}} a {{to}} de {{total}} cuentas',
    rowsPerPage: 'Filas por página',
    notLoaded: 'Sin cargar',
    noResults: '0 resultados',
    colTenant: 'Cuenta',
    colPlan: 'Plan',
    colCreationStatus: 'Estado de creación',
    colTransactionErrors: 'Errores de transacción',
    colStartDay: 'Día de inicio',
    colShippedLastMonth: 'Enviados el periodo pasado',
    colAvgShippedLastMonth: 'Promedio por día, periodo pasado',
    colShippedThisMonth: 'Enviados este periodo',
    colAvgShippedThisMonth: 'Promedio por día, este periodo',
    colPlanMax: 'Máximo del plan',
    colUsers: 'Usuarios regulares / solo administrativos',
    colLastActivity: 'Última actividad',
    colNotes: 'Notas',
    colUrl: 'URL',
    colStripe: 'Stripe',
    colTestTenant: 'Cuenta de prueba',
    colLastCharge: 'Último cargo en Stripe',
    colLastImportStoreType: 'Tipo de tienda de la última importación',
    colAccountStatus: 'Estado de la cuenta',
    open: 'Abrir',
    noActivityYet: 'Sin actividad todavía',
    notChargedYet: 'Sin cargos todavía',
    select: 'Seleccionar',
    selectAll: 'Seleccionar todo',
    filtersTitle: 'Filtros y orden',
    filtersSubtitle: 'Se aplica a la lista de cuentas',
    filterStatus: 'Estado',
    sortBy: 'Ordenar por',
    sortTenantAz: 'Cuenta, de la A a la Z',
    apply: 'Aplicar',
    reset: 'Restablecer',
    sortRegularUsers: 'Usuarios regulares',
    sortAdminOnlyUsers: 'Usuarios solo administrativos',
    shippedOfMax: '{{shipped}} de {{max}}',
    previous: 'Anterior',
    next: 'Siguiente',
    closeSelection: 'Salir del modo de selección',
    deleteConfirm:
      '¿Eliminar {{name}}? Sus datos se conservan y se puede restaurar.',
    restoreConfirm: 'Escriba el nombre de la cuenta para restaurarla',
    duplicatePrompt: 'Nombre para la copia de {{name}}',
    deleteSummaryConfirm: '¿Eliminar el resumen de importación de {{name}}?',
    deleteSummary: 'Eliminar resumen',
    deleteSummaryDisabledTooltip: 'Seleccione una cuenta para eliminar su resumen de importación.',
    colCreated: 'Creada',
    colWorkflow: 'Flujo de escaneo',
    workflowDefault: 'Predeterminado',
    workflowScanToCart: 'Scan to Cart',
    workflowProductFirstPutWall: 'Product First Put Wall',
    workflowMultiPutWall: 'Multi Put Wall',
    workflowPickTote: 'Pick Tote',
    unlimited: 'Ilimitado',
    planPerMonth: '{{amount}}/mes',
    planPerYear: '{{amount}}/año',
    periodSince: 'desde el {{date}}',
    periodRange: '{{from}} a {{to}}',
    columnPrefsLoadFailed: 'No se pudieron cargar sus columnas guardadas, así que se muestran las predeterminadas. Los cambios de columnas no se guardarán hasta que recargue la página.',
    columnPrefsSaveFailed: 'No se pudo guardar su elección de columnas: {{error}}',
    dash: '—'
  }
};
export default es;
